
interface LocalTimeProps  {
    timezone: string
    className?: string
}
export const LocalTime = ({timezone, className}: LocalTimeProps) => {



    const getTimeByTimezone = (timezone: string) => {
        if (!timezone) return '';
        const date = new Date();
        return date.toLocaleString('en-US', {
            timeZone: timezone,
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        });
    };

    return (
    <div>
        <div className={'text-ink-muted text-sm flex items-center font-normal ' + className}>
            {getTimeByTimezone(timezone)}
        </div>
    </div>
    )
}